import Service, { service, type Registry as Services } from '@ember/service';
import { tracked } from '@glimmer/tracking';

interface User {
  email?: string;
  phoneNumber?: string;
  lastName?: string;
  firstName?: string;
  locale?: string;
  // oxlint-disable-next-line typescript/no-explicit-any
  set: (key: string, value: any) => void;
  save: () => Promise<void>;
}

export default class CurrentUserService extends Service {
  @service declare session: Services['session'];
  // @ts-expect-error -- this service is not typed yet
  @service segment;
  // @ts-expect-error -- this service is not typed yet
  @service store;

  @tracked user?: User | null;

  async load(): Promise<void> {
    if (this.session.isAuthenticated) {
      // oxlint-disable-next-line typescript/consistent-type-assertions, typescript/no-unsafe-member-access
      this.user = (await this.store.queryRecord('user', {})) as User;
      let { email, phoneNumber, lastName, firstName } = this.user;
      // oxlint-disable-next-line typescript/no-unsafe-member-access
      this.segment.identify({ email, phoneNumber, lastName, firstName });
    }
  }
}

declare module '@ember/service' {
  interface Registry {
    'current-user': CurrentUserService;
    currentUser: CurrentUserService;
  }
}
